import { endPoints } from "@/constants/apiSetting";
import httpClient from "@/common/service/HttpClient";
const JobAdsService = {
  getAllJobAdsList(obj) {
    return httpClient.post(endPoints.getAllJobAdsList, obj);
  },
  getJobadListForCandidates(obj) {
    return httpClient.post(endPoints.getJobadListForCandidates, obj);
  },
  getAllJobAdListByCandidateId(obj) {
    return httpClient.post(endPoints.getAllJobAdListByCandidateId, obj);
  },
  getJobAdsDetailByJobAdCode(obj) {
    return httpClient.post(endPoints.getJobAdsDetailByJobAdCode, obj);
  },
  saveJobAd(obj) {
    return httpClient.post(endPoints.saveJobAd, obj);
  },
  deleteJobAds(obj) {
    return httpClient.post(endPoints.deleteJobAds, obj);
  },
};

export default JobAdsService;



// WEBPACK FOOTER //
// ./src/service/JobAdsService.js